import { Button as ChakraButton } from '@chakra-ui/react';
import { forwardRef } from 'react';

import type { StyleProps } from '../../../types';
import { ButtonDefaultProps, type ButtonProps } from './Button.types';

const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ variant, ...props }, ref) => {
  const ButtonStyles: StyleProps = variant === 'outline' ? { bg: 'bg' } : {};

  return <ChakraButton ref={ref} variant={variant} {...ButtonStyles} {...props} />;
});

Button.displayName = 'Button';
Button.defaultProps = ButtonDefaultProps;

export { Button };
